<div class="form-box">
  <form *ngIf="meetingForm" [formGroup]="meetingForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-title">
          <b>Technical Seller:</b> Client meeting, with IBMer attending. Deal registration required.
        </div>
      </div>
    </div>
    <div class="row" *ngIf="isPrc">
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'Select a user' | translate }}:</label>
          <input
            class="form-control"
            type="text"
            formControlName="userId"
            [ngbTypeahead]="userTypeahead"
            [resultFormatter]="formatUsername"
            [inputFormatter]="formatUsername"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'Date of meeting' | translate }}</label>
          <input
            class="form-control"
            formControlName="meetingDate"
            type="date"
            [min]="programPeriod?.startDate?.substring(0, 10)"
            [max]="programPeriod?.endDate?.substring(0, 10)"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'Name of customer' | translate }}</label>
          <input class="form-control" formControlName="customerName" type="text" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'Deal registration #' | translate }}</label>
          <input class="form-control" formControlName="dealRegistrationNumber" type="text" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'IBM Sales Representative First name' | translate }}</label>
          <input class="form-control" formControlName="ibmFirstName" type="text" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'IBM Sales Representative Last name' | translate }}</label>
          <input class="form-control" formControlName="ibmLastName" type="text" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'Email of IBM Sales Representative' | translate }}</label>
          <input class="form-control" formControlName="salesRepEmail" type="email" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ 'Type of meeting' | translate }}</label>
          <select class="form-control" formControlName="meetingTypeId">
            <option value="">{{ 'Select' | translate }}</option>
            <option *ngFor="let type of meetingTypes" [value]="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9 my-auto">
        {{
          'Upon submission a triggered mail will be sent requesting confirmation of the meet.'
            | translate
        }}
        <p>*Upon confirmation $ will be auto loaded to your IBM Rewards Card.</p>
      </div>
      <div class="col-md-3">
        <button type="submit" class="btn btn-primary submit" [disabled]="submitting">
          {{ 'Submit' | translate }} <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </form>
</div>
